import styled, { css } from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const LinkBaseStyles = css`
  color: ${colors.blue7};
  text-decoration: none;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  &:visited {
    color: ${colors.blue7};
    text-decoration: none;
  }
`;

export const Link = styled.a`
  ${LinkBaseStyles}
`;
